import React from 'react'

const Cart = () => {
    return (
        <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_cart)">
                <path
                    d="M22.6758 18.9616C23.7695 18.9616 24.732 18.3637 25.2279 17.4595L30.4487 7.99492C30.9883 7.03242 30.2883 5.83659 29.18 5.83659H7.59662L6.22578 2.91992H1.45703V5.83659H4.3737L9.6237 16.9053L7.65495 20.4637C6.59037 22.4178 7.99037 24.7949 10.207 24.7949H27.707V21.8783H10.207L11.8112 18.9616H22.6758ZM8.98203 8.75326H26.7008L22.6758 16.0449H12.4383L8.98203 8.75326ZM10.207 26.2533C8.60287 26.2533 7.30495 27.5658 7.30495 29.1699C7.30495 30.7741 8.60287 32.0866 10.207 32.0866C11.8112 32.0866 13.1237 30.7741 13.1237 29.1699C13.1237 27.5658 11.8112 26.2533 10.207 26.2533ZM24.7904 26.2533C23.1862 26.2533 21.8883 27.5658 21.8883 29.1699C21.8883 30.7741 23.1862 32.0866 24.7904 32.0866C26.3945 32.0866 27.707 30.7741 27.707 29.1699C27.707 27.5658 26.3945 26.2533 24.7904 26.2533Z"
                    fill="currentColor"
                    stroke="none"
                />
            </g>
            <defs>
                <clipPath id="clip0_cart">
                    <rect width="35" height="35" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    )
}

export default Cart
